import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { environment } from 'mds-ui/environments/environment';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx';
import { AttachmentsVO, AttachmentsRes, DownloadFileVO, AttachmentRequest, AttachmentsSearchVO, AttachmentsUpdateVO } from 'mds-ui/app/modules/seminarian/models/attachments';

@Injectable()
export class AttachmentsService {
    public attachmentsVOList: AttachmentsVO[];
    public attachmentsVO: AttachmentsVO;
    public attachmentsSearchVO:AttachmentsSearchVO;
    public attachmentsUpdateVO:AttachmentsUpdateVO;
    public filesToUpload: Array<File>;
    filenames: string[];
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {

        this.handleError = httpErrorHandler.createHandleError('AttachmentsService');
    }
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    attachmentLiveScanInfoInit() {
        this.attachmentsVOList = [];
        this.attachmentsVO = new AttachmentsVO();
    }
    getAttachmentsByPersonId(id: number, appId: number, reqUser: string): Observable<AttachmentsVO[]> {
        return this._http.get<AttachmentsVO[]>(
            environment.getAttachmentsByPersonIdUrl + id + "?appId=" + appId + "&userName=" + reqUser, this.httpOptions)
            .pipe(
                catchError(this.handleError('getAttachmentsByPersonId', []))
            );

    }
    postAttachments(filesToUploadParam: Array<File>, attachmentRequest: AttachmentRequest): Observable<any> {
        let formData: FormData = new FormData();
        for (const element of filesToUploadParam) {
            let file: File = element
            formData.append(`files`, file, file.name);
        }
        formData.append('attachmentRequest',
            new Blob([JSON.stringify(attachmentRequest)], {
                type: 'application/json'
            }));
        let options = {
            headers: new HttpHeaders({
                'enctype': 'multipart/form-data',
                "Cache-Control": "no-cache",
                Pragma: "no-cache"
            })
        };
        return this._http.post<AttachmentsRes>(environment.postAttachmentsUrl, formData, options).pipe(
            catchError(this.handleError('postAttachments', []))
        );
    }
    // postAttachments( filesToUploadParam: Array<File>, attachmentRequest: AttachmentRequest): Observable<any> {
    //     const formData: FormData = new FormData();

    //     for (let i: number = 0; i < filesToUploadParam.length; i++) {
    //         const file: File = filesToUploadParam[i];
    //         formData.append(`files`, file, file.name);

    //     }
    //     let options = {
    //         headers: new HttpHeaders({
    //             'enctype': 'multipart/form-data',

    //             "Cache-Control": "no-cache",
    //             Pragma: "no-cache"
    //         })
    //     };

    //     return this._http.post<AttachmentsRes>(
    //         environment.postAttachmentsUrl + attachmentRequest, formData, options)
    //         .pipe(
    //             catchError(this.handleError('postAttachments', []))
    //         );
    // }
    downloadFiles(id: number, userName: string): Observable<DownloadFileVO[]> {
        return this._http.get<DownloadFileVO[]>(
            environment.getFilesUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('deleteAttachmentById', []))
            );
    }
    deleteAttachmentById(id: number, userName: string): Observable<any> {
        return this._http.get<AttachmentsVO[]>(environment.deleteAttachmentByIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(catchError(this.handleError('deleteAttachmentById', [])));
    }
    updateDescriptionById(id: number, fileDescription: string,
        userName: string): Observable<AttachmentsVO[]> {
        return this._http.post<AttachmentsVO[]>(environment.updateDescriptionByIdURL + "?id=" + id + "&description=" + fileDescription + "&userName=" + userName, this.httpOptions).pipe(
            catchError(this.handleError('updateDescriptionById()', [])));
    }
    updateAttachments(attachmentsUpdateVO: AttachmentsUpdateVO): Observable<AttachmentsUpdateVO[]> { 
        return this._http.put<AttachmentsUpdateVO[]>(environment.updateAttachmentsURL, attachmentsUpdateVO, this.httpOptions).pipe(
            catchError(this.handleError('updateAttachments()', [])));
    }
    getAttachmentsCount(attachmentsSearchVO: AttachmentsSearchVO): Observable<AttachmentsRes[]> {
        return this._http.post<AttachmentsRes[]>(environment.getAttachmentsCountUrl + "/count", attachmentsSearchVO, this.httpOptions).pipe(
            catchError(this.handleError('getAttachmentsCount()', [])));
    }

    getAttachmentsList(attachmentsSearchVO: AttachmentsSearchVO): Observable<AttachmentsRes[]> {
        return this._http.post<AttachmentsRes[]>(environment.getAttachmentsListUrl , attachmentsSearchVO, this.httpOptions).pipe(
            catchError(this.handleError('getAttachmentsList()', [])));
    }


}